module.exports = {"TITLE":"Offres Tab","DESCRIPTION":"Voici les offres Tab qui ont été promues sur Tuango. Cliquez sur les images pour obtenir plus d'informations sur la performance et les résultats de chaque offre.","TOTAL_STATS":"Ventes totales","TAB_DEALS":"Offres Tab","CLAIMS_STATS":"Cartes liées","TRX_STATS":"Transactions<br><small>#conversionRate#% d'offres réclamées</small>","SALES_STATS":"Ventes totales","STATUS_ACTIVE":"Actif","STATUS_ENDED":"Fini"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/fr/deals.json
// module id = 356
// module chunks = 8